<template>
  <div class="portal-page__clientdown">
    <!-- header -->
    <div class="portal-page__clientdown__top">
      <div ref="bannerH" class="portal-page__clientdown__top__content">
        <h2 class="portal-page__clientdown__top__content__title">客户端下载</h2>
      </div>
    </div>
    <!-- 下载方式 -->
    <div class="portal-page__clientdown__main__wrap">
      <ul class="portal-page__clientdown__main">
        <li
          class="portal-page__clientdown__main__item--wrap"
          v-for="(item, index) in downloadWay"
          :key="index"
        >
          <div class="portal-page__clientdown__main__item">
            <div
              @click="handleDown(item, index)"
              class="portal-page__clientdown__main__item__type"
            >
              <div class="portal-page__clientdown__main__item__img">
                <img :src="item.img" />
                <p>{{ item.type }}</p>
              </div>
              <div
                v-if="index === 0"
                class="portal-page__clientdown__main__item__hover is-pc"
              >
                <img
                  :src="
                    require('./../../assets/image/portal/client_download.png')
                  "
                />
                <p>{{ item.type }}</p>
              </div>
              <qrcode-vue
                :value="item.packageUrl"
                size="100"
                level="H"
                v-else
                class="portal-page__clientdown__main__item__hover"
              ></qrcode-vue>
            </div>
            <div class="portal-page__clientdown__main__item__info">
              <div class="portal-page__clientdown__main__item__intro">
                <span>软件名称：</span>
                <p>{{ item.name }}</p>
              </div>
              <div class="portal-page__clientdown__main__item__intro">
                <span>软件简介：</span>
                <p>{{ item.introduction }}</p>
              </div>
              <div class="portal-page__clientdown__main__item__intro">
                <span>软件版本：</span>
                <p>{{ item.ver }}</p>
              </div>
              <div class="portal-page__clientdown__main__item__intro">
                <span>更新日期：</span>
                <p>{{ item.createDateL }}</p>
              </div>
              <div class="portal-page__clientdown__main__item__intro">
                <span>软件大小：</span>
                <p>{{ item.fileSize }}</p>
              </div>
              <div class="portal-page__clientdown__main__item__intro">
                <span>推荐环境：</span>
                <p>{{ item.systemVersions }}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { setProvider } from "./../../api/index";
import moment from "moment";
import QrcodeVue from "qrcode.vue";

export default {
  data() {
    return {
      downloadWay: [
        {
          name: "萤石商业智居", // 软件名称
          type: "PC客户端",
          img: require("./../../assets/image/portal/client_windows.png"),
          upgradeType: 4, // 表示pc客户端
          introduction: "--", // 软件简介：
          ver: "--", // 版本，
          createDateL: "", // 更新时间
          fileSize: "--", // 软件大小：
          systemVersions: "Win7/Win8/Win10", // 推荐环境，
          packageUrl: "" // 全量包地址
        },
        {
          name: "萤石商业智居", // 软件名称
          type: "Android客户端",
          img: require("./../../assets/image/portal/client_android.png"),
          upgradeType: 3, // 表示安卓客户端
          introduction: "--", // 软件简介：
          ver: "--", // 版本，
          createDateL: "", // 更新时间
          fileSize: "--", // 软件大小：
          systemVersions: "安卓6.0及以上版本", // 推荐环境
          packageUrl: "" // 全量包地址
        },
        {
          name: "萤石商业智居", // 软件名称
          type: "IOS客户端",
          img: require("./../../assets/image/portal/client_iphone.png"),
          upgradeType: 2, // 表示安卓客户端
          introduction: "--", // 软件简介：
          ver: "--", // 版本，
          createDateL: "", // 更新时间
          fileSize: "--", // 软件大小：
          systemVersions: "iOS 11.0及以上版本", // 推荐环境
          packageUrl: "" // 全量包地址
        }
      ]
    };
  },
  components: {
    QrcodeVue
  },
  mounted() {
    this.getVersionInfo();
  },
  methods: {
    // 获取版本号、大小、日期信息
    async getVersionInfo() {
      try {
        const result = await setProvider.getVersion();
        const configs = (result || {}).data || [];
        let pcSetupConfig = configs.find(ele => ele.upgradeType === 4) || {};
        let androidSetupConfig =
          configs.find(ele => ele.upgradeType === 3) || {};
        let iOSSetupConfig = configs.find(ele => ele.upgradeType === 2) || {};
        console.log(configs, pcSetupConfig, androidSetupConfig, iOSSetupConfig);

        if (pcSetupConfig) {
          pcSetupConfig = {
            ...this.downloadWay[0],
            introduction: pcSetupConfig.introduction || "--", // 软件简介：
            ver: pcSetupConfig.ver ? `V${pcSetupConfig.ver}` : "--",
            createDateL: pcSetupConfig.createDateL
              ? moment(pcSetupConfig.createDateL).format("YYYY/MM/DD")
              : "--", // 更新时间
            fileSize: pcSetupConfig.fileSize
              ? (pcSetupConfig.fileSize / 1024).toFixed(1) + "M"
              : "--", // 软件大小：
            packageUrl: pcSetupConfig.packageUrl
          };
        }
        if (androidSetupConfig) {
          androidSetupConfig = {
            ...this.downloadWay[1],
            introduction: androidSetupConfig.introduction || "--", // 软件简介：
            ver: androidSetupConfig.ver ? `V${androidSetupConfig.ver}` : "--",
            createDateL: androidSetupConfig.createDateL
              ? moment(androidSetupConfig.createDateL).format("YYYY/MM/DD")
              : "--", // 更新时间
            fileSize: androidSetupConfig.fileSize
              ? (androidSetupConfig.fileSize / 1024).toFixed(1) + "M"
              : "--", // 软件大小：
            packageUrl: "https://es.ys7.com/0tgzh"
          };
        }
        if (iOSSetupConfig) {
          iOSSetupConfig = {
            ...this.downloadWay[2],
            introduction: iOSSetupConfig.introduction || "--", // 软件简介：
            ver: iOSSetupConfig.ver ? `V${iOSSetupConfig.ver}` : "--",
            createDateL: iOSSetupConfig.createDateL
              ? moment(iOSSetupConfig.createDateL).format("YYYY/MM/DD")
              : "--", // 更新时间
            fileSize: iOSSetupConfig.fileSize
              ? (iOSSetupConfig.fileSize / 1024).toFixed(1) + "M"
              : "--", // 软件大小：
            packageUrl: "https://es.ys7.com/0tgzh"
          };
        }
        this.downloadWay = [
          pcSetupConfig || {
            ...this.downloadWay[0]
          },
          androidSetupConfig || {
            ...this.downloadWay[1]
          },
          iOSSetupConfig || {
            ...this.downloadWay[2]
          }
        ];
        console.log(this.downloadWay);
      } catch (e) {
        console.log(e);
      }
    },

    // 下载客户端
    handleDown(data, index) {
      // 当为客户端，并且有下载链接
      if (index === 0 && data.packageUrl) {
        window.open(data.packageUrl);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.portal-page__clientdown {
  overflow: hidden;
  &__top {
    position: relative;
    height: 300px;
    background: #516983 url("./../../assets/image/portal/download_banner.jpg")
      no-repeat center;
    text-align: center;
    &__content {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 1200px;
      height: 300px;
      margin: 0 auto;
      &__title {
        font-size: 40px;
        color: #fff;
      }
    }
  }
  &__main {
    &__wrap {
      // background: red;
    }
    max-width: 1200px;
    margin: 0 auto;
    padding: 66px 40px;
    &__item {
      &--wrap {
        padding: 10px 0;
      }
      display: flex;
      padding: 20px;
      background: #eee;
      transition: all ease-in-out 0.28s;
      &:hover {
        box-shadow: 6px 0 10px 6px #ccc;
        .portal-page__clientdown__main__item__img {
          transform: scale(0.5);
          opacity: 0;
        }
        .portal-page__clientdown__main__item__hover {
          transform: scale(1);
          opacity: 1;
        }
      }
      &__type {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 120px;
        height: 120px;
        border: 1px solid #999;
        margin-top: 5px;
      }
      &__img {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transition: all ease-in-out 0.3s;
        img {
          width: 60px;
          margin-bottom: 6px;
        }
        p {
          font-size: 16px;
          color: #666;
          line-height: 20px;
        }
      }
      &__hover {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 100px;
        height: 100px;
        transform: scale(0.5);
        opacity: 0;
        transition: all ease-in-out 0.3s;
        &.is-pc {
          top: 0;
          left: 0;
          display: flex;
          flex-direction: column;
          width: 120px;
          height: 120px;
          align-items: center;
          justify-content: center;
          color: #fff;
          background: #4285f4;
          cursor: pointer;
          img {
            max-width: 60px;
            margin-bottom: 13px;
          }
          p {
            font-size: 16px;
            color: #fff;
            line-height: 20px;
          }
        }
      }
      &__info {
        flex: 1;
        width: 100px;
        padding-left: 30px;
      }
      &__intro {
        display: flex;
        font-size: 14px;
        color: #666;
        line-height: 24px;
        & > span {
          min-width: 80px;
        }
        & > p {
          flex: 1;
          width: 20px;
          word-break: break-all;
          padding: 0;
          margin: 0;
        }
      }
    }
  }
}
</style>
